interface IconProps extends React.HtmlHTMLAttributes<HTMLButtonElement> {
    icon: string
    size?: any
    tintColor?: string
}

export const IconSVG = ({
                            icon,
                            size = '32px',
                            tintColor,
                            ...rest
                        }: IconProps) => {
    // const image = icon ? require(`../../assets/icons/svg/${icon}.svg`) : ''
    return (
        <span {...rest}>
      {tintColor ? (
          <div
              className="icon icon-svg-mask"
              style={{
                  maskImage: `url(${icon})`,
                  WebkitMaskImage: `url(${icon})`,
                  backgroundColor: tintColor,
                  width: size,
                  height: size,
              }}
          ></div>
      ) : (
          <img className="icon" src={icon} width={size} height={size}/>
      )}
    </span>
    )
}
